<template>
  <b-button
    :style="buttonStyle"
    :variant="variant"
    :size="size"
    :type="type"
    :class="buttonClass"
    :disabled="isBusy || disabled"
    @click="$emit('click')"
  >
    <slot>
      {{ text }}
    </slot>
    <b-spinner
      class="ml-2"
      small
      v-if="isBusy"
    />
  </b-button>
</template>

<script>

export default {
  name: 'SaveButton',
  components: {
  },
  props: {
    text: {
      type: String,
      default: 'Lưu',
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'sm',
    },
    type: {
      type: String,
      default: 'submit',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonStyle: {
      type: Object,
      default: () => ({
        fontWeight: '600',
        minWidth: '70px',
      }),
    },
    buttonClass: {
      type: String,
      default: 'font-weight-bolder',
    },
  },
}
</script>
